/* eslint-disable prettier/prettier */
import { Link } from "gatsby";
import React from "react";

import { linkParser } from "../../utils/linkParser"

const isInternalLink = (url) => {
    return /^\/(?!\/)/.test(url); // Checks if the URL starts with a single slash
};

const LinkComponent = ({ children, className, dest, onClick, src, style, type }) => {

    const linkType = type || (isInternalLink(src) ? 'internal' : 'external');
    const link = linkParser(src)

    if (linkType === 'internal') {
        return (
            <Link className={className} onClick={onClick} style={style} to={link}>{children}</Link>
        )
    }
    if (linkType === 'external') {
        return (
            <a className={className} href={src} onClick={onClick} rel="noreferrer" style={style} target={dest === linkType ? "_blank" : undefined}>{children}</a>
        )
    } 
        return (
            <span className={className} onClick={onClick} onKeyUp={onClick} role="button" style={style} tabIndex="0">{children}</span>
        );
    
}

export default LinkComponent;